import { useState, type FormEvent } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/daftck1tto0ceqqnhh40";

export default function NewsletterForm() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">(
    "idle",
  );
  const [formError, setFormError] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const trap = (formData.get("contact_alt") as string) || "";
    // 蜜罐被机器人填写时：不走网络请求，仅给出与正常提交一致的反馈
    if (trap.trim()) {
      setStatus("success");
      form.reset();
      return;
    }

    const email = (formData.get("email") as string) || "";
    if (!email) {
      setStatus("error");
      setFormError("请填写有效的邮箱地址后再提交。");
      return;
    }

    setStatus("loading");
    setFormError("");
    const body = new URLSearchParams();
    body.append("email", email);

    try {
      const response = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } | null =
        null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message ||
        parsed?.meta?.detail ||
        (parsed && "message" in parsed
          ? (parsed as { message?: string }).message
          : "") ||
        "";

      const okCode = parsed?.code === "OK";
      if (response.ok && okCode && !/spam|form data is spam/i.test(responseText)) {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
        setFormError(serverMsg || "提交失败，请稍后再试或检查邮箱格式。");
      }
    } catch {
      setStatus("error");
      setFormError("网络异常，暂时无法提交，请稍后重试。");
    }
  };

  return (
    <form onSubmit={handleSubmit} data-readdy-form className="w-full">
      {/* 反垃圾蜜罐 */}
      <div className="field-trap" aria-hidden="true">
        <label htmlFor="contact_alt">公司名称</label>
        <input
          type="text"
          id="contact_alt"
          name="contact_alt"
          tabIndex={-1}
          autoComplete="off"
          readOnly
        />
      </div>

      {status === "success" ? (
        <div className="flex items-center justify-center gap-3 rounded-2xl bg-accent-100 px-5 py-4 text-accent-900">
          <i className="ri-checkbox-circle-line text-2xl" aria-hidden="true"></i>
          <span className="text-sm font-medium">
            订阅成功！今后每个大瓜，我们都会第一时间推送到你的邮箱。
          </span>
        </div>
      ) : (
        <div className="w-full">
          <div className="flex w-full flex-col gap-3 sm:flex-row">
            <label htmlFor="subscribe-email" className="sr-only">
              邮箱地址
            </label>
            <input
              type="email"
              id="subscribe-email"
              name="email"
              required
              autoComplete="email"
              placeholder="输入你的邮箱，追瓜不迷路"
              className="h-12 w-full flex-1 rounded-full border border-background-200 bg-background-50 px-5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-300/50"
            />
            <button
              type="submit"
              disabled={status === "loading"}
              className="flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-70"
            >
              {status === "loading" ? (
                <i className="ri-loader-4-line animate-spin text-lg"></i>
              ) : (
                <>
                  <i className="ri-mail-send-line text-lg" aria-hidden="true"></i>
                  立即订阅
                </>
              )}
            </button>
          </div>
          <p className="mt-2.5 text-center text-xs text-background-50/80 sm:text-left">
            我们只在你关心的瓜新鲜出炉时发邮件，绝不打扰，随时可退订。
          </p>
        </div>
      )}

      {status === "error" && (
        <p className="mt-3 flex items-center gap-2 rounded-xl bg-primary-100 px-4 py-2.5 text-sm text-primary-700">
          <i className="ri-error-warning-line text-lg" aria-hidden="true"></i>
          {formError}
        </p>
      )}
    </form>
  );
}